if (!customElements.get("product-wish-list")) {
    // noinspection JSUnusedGlobalSymbols
    class ProductWishList extends HTMLElement {
        constructor() {
            super();
        }

        /**
         * Invoked each time one of the custom element's attributes is added, removed, or changed
         */
        attributeChangedCallback() {
            this.rendered = false;
            this.html = undefined;
            this.init();
        }

        /**
         * Runs when element is created
         */
        connectedCallback() {
            if (!this.rendered) {
                this.init();
            }
        }

        /**
         * Initialize state data
         */
        setupData() {
            this.data = {
                column_desktop: parseInt(this.getAttribute("column_desktop")) || 3,
                wishListBtnSelector: "wish-list-button",
                message: {
                    emptyItem: this.getAttribute("messageEmptyItem") || "お気に入りリストに登録している商品はありません",
                    error: this.getAttribute("messageError") || "データが取得できない。",
                },
            };
        }

        /**
         * Initialize data
         */
        init() {
            this.startLoading();
            this.setupData();
            this.loaded((swat) => {
                this.swat = swat;
                this.render();
            });
            this.rendered = true;
        }

        /**
         * When the user click the wishlist button
         */
        addEventForWishListButton() {
            let wishListButtonSelector = this.data.wishListBtnSelector;
            let wishListButtons = this.querySelectorAll(wishListButtonSelector);
            if (wishListButtons.length) {
                wishListButtons.forEach((button) => {
                    // Called when wishlist status change event in `assets/wish-list-button.js`
                    button.addEventListener("changeStatus", () => {
                        let wishListButtonElements = this.querySelectorAll(wishListButtonSelector);
                        if (wishListButtonElements.length > 1) {
                            button.closest('.grid__item').remove();
                        } else {
                            this.renderEmpty();
                        }
                    });
                });
            }
        }

        /**
         * Initialize connect to App
         * @param callback
         */
        loaded(callback) {
            if (!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }
            window.SwymCallbacks.push((swat) => {
                callback(swat);
            });
        }

        /**
         * @param callback
         */
        afterRender(callback) {
            setTimeout(() => {
                callback();
            }, 600);
            const content = this.querySelector('[data-js="content"]');
            content.parentElement.classList.remove("default");
        }

        /**
         * Based on file `search.wishlist.liquid` to get HTML json
         *
         * @param list
         * @returns {Promise<any>}
         */
        async renderProductHTML(list) {
            try {
                let variantIds = list.map((item) => {
                    return item.epi;
                });
                let productIds = list.map((item) => {
                    return `(id:"${item.empi}")`;
                });
                let queryString = Array.from(new Set(productIds)).join(" OR ");
                if (list.length > 0) {
                    return await fetch(`${window.origin}/search?view=wishlist&variant_ids=` + variantIds.join("-") + "&type=product&q=" + queryString, {
                        credentials: "same-origin",
                        method: "GET",
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.items && data.items.length) {
                                let html = "";
                                let itemData = data.items.filter((item) => item);
                                variantIds.forEach((productVariantId) => {
                                    let productCard = itemData.find((productItem) => productItem.id === productVariantId);
                                    if (productCard) {
                                        html += productCard.html;
                                    }
                                });
                                return {
                                    listHtml: html,
                                    total: data.total,
                                };
                            } else {
                                this.renderEmpty();
                            }
                        });
                } else {
                    this.renderEmpty();
                }
            } catch (e) {
                console.log(e);
                this.renderError();
            }
        }

        /**
         * Render HTML
         */
        render() {
            this.swat.fetch((list) => {
                // Invoked at most once after being added
                if (typeof this.html === "undefined" && list.length) {
                    this.renderProductHTML(list).then((data) => {
                        if (!data || !data.listHtml) return;
                        this.html = data.listHtml;
                        const content = this.querySelector('[data-js="content"]');
                        content.style.display = "none";
                        content.innerHTML = data.listHtml;
                        this.afterRender(() => {
                            this.addEventForWishListButton();
                            content.style.display = "flex";
                            this.endLoading();
                        });
                    });
                } else {
                    this.renderEmpty();
                    this.endLoading();
                }
            });
        }

        /**
         * Show Empty Message
         */
        renderEmpty() {
            const content = this.querySelector('[data-js="content"]');
            content.parentElement.classList.add("default");
            content.parentElement.innerHTML = `<p class="product-wishlist__text--empty">${this.data.message.emptyItem}</p>`;
        }

        /**
         * Show Error Message
         */
        renderError() {
            const content = this.querySelector('[data-js="content"]');
            content.parentElement.classList.add("default");
            content.parentElement.innerHTML = `<span>${this.data.message.error}</span>`;
        }

        startLoading() {
            this.classList.add("loading");
        }

        endLoading() {
            this.classList.remove("loading");
        }
    }

    customElements.define("product-wish-list", ProductWishList);
}